export default "__VITE_ASSET__DoTvefLA__"